import React from 'react';
import { Spin, Alert, Card, Typography } from 'antd';
import {
  LoadingOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from '@ant-design/icons';
import styles from './ReportStatusDisplay.module.css';

const { Title } = Typography;

const ReportStatusDisplay = ({ status, error }) => {
  // Don't show if idle
  if (status === 'idle') {
    return null;
  }

  // Render different views based on status
  if (status === 'completed') {
    return (
      <Card className={styles.statusCard}>
        <Alert
          message="Report Generated Successfully"
          description="Your report is ready to view below."
          type="success"
          showIcon
          icon={<CheckCircleOutlined />}
        />
      </Card>
    );
  }

  if (status === 'failed') {
    return (
      <Card className={styles.statusCard}>
        <Alert
          message="Report Generation Failed"
          description={error || 'An error occurred while generating your report. Please try again.'}
          type="error"
          showIcon
          icon={<CloseCircleOutlined />}
        />
      </Card>
    );
  }

  // Show minimal centered spinner for generating/queued/processing
  return (
    <Card className={styles.statusCard}>
      <div className={styles.spinnerContainer}>
        <Spin indicator={<LoadingOutlined style={{ fontSize: 36 }} spin />} />
        <Title level={4} className={styles.title}>
          Generating your report…
        </Title>
      </div>
    </Card>
  );
};

export default ReportStatusDisplay;
